import { Ano } from './../../../distribuicao-mensal-aos-municipio/shared/model/distribuicaoMensalMunicipio.model';
import { MensagemErroModel } from './../../../../shared/model/mensagem-erro.model';

export class DadosOnInitModelView{
  ListaAno: Ano[];
  ListaMunicipio: Municipio[];
  objetoMensagem: MensagemErroModel;
}

export class IndiceParticipacaoMunicipioFiltro{
  IdAno: string
  IdMunicipio: string;
  DescricaoMunicipio: string;
}

export class IndiceParticipacaoMunicipio{
  DescricaoMunicipio: string;
  ValorIndiceParticipacaoMunicipio: string;
}

export class Municipio{
  IdMunicipio: string;
  Descricao: string;
  SigUnidadeFederacao: string;
}

export class IndiceParticipacaoMunicipioModelView{
  ListaIndiceMensalMunicpio: IndiceParticipacaoMunicipio[];
  objetoMensagem: MensagemErroModel;
}


// WEBPACK FOOTER //
// ./src/app/consulta/indice-participacao-municipio/shared/model/IndiceParticipacaoMunicipio.model.ts